import { Box, Stack } from "@mui/material";
import {
  EllipseLeft,
  EllipseLeft2,
  EllipseLeft3,
  EllipseRight,
  EllipseRight2,
  EllipseRight3,
} from "./Style";

const Background = () => {
  const sx = {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    zIndex: 0,
    backgroundColor: "#f8f8f6",
    overflow: "hidden",
  };

  return (
    <Box sx={sx}>
      <Stack
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh",
        }}
      >
        {/* <EllipseLeft />
                <EllipseLeft2 />
                <EllipseLeft3 /> */}
        <EllipseRight />
        <EllipseRight2 />
        <EllipseRight3 />
      </Stack>
      <Stack
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh",
        }}
      >
        <EllipseLeft />
        <EllipseLeft2 />
        <EllipseLeft3 />
        <EllipseRight />
        <EllipseRight2 />
        <EllipseRight3 />
      </Stack>
    </Box>
  );
};

export default Background;
